export default "/images/web-button-saga-cropped.png?d8a63ad64c6e5c93f76e685767cb6206";